import { Navigate } from 'react-router-dom'
import { routesProfile } from '../consts'
import { RequireAuth } from '../hoc/RequireAuth'
import ProfileOnboardingLayout from '../layouts/ProfileOnboardingLayout'
import { UserProfileSettings } from '../pages/Profile/UserProfileSettings'

export const profileOnboardingRoutes = [
  {
    path: routesProfile.ROOT.path,
    element: (
      <RequireAuth>
        <ProfileOnboardingLayout />
      </RequireAuth>
    ),
    permissions: routesProfile.ROOT.permissions,
    children: [
      {
        index: true,
        element: <Navigate to={routesProfile.PROFILE.path} replace />,
      },
      {
        path: routesProfile.PROFILE.path,
        element: (
          <RequireAuth>
            <UserProfileSettings />
          </RequireAuth>
        ),
        permissions: routesProfile.ROOT.permissions,
      },
      {
        path: '*',
        element: <Navigate to={routesProfile.PROFILE.path} replace />,
      },
    ],
  },
]
